import styled from 'styled-components'

export const Container = styled.div<{ $selected: boolean }>`
	width: 100%;
	border-radius: 18px;
	background: #fff;
	border: ${({ $selected }) => ($selected ? '1.5px' : '1px')} solid
		${({ $selected }) =>
			$selected
				? 'var(--training-accent, #dcf831)'
				: 'rgba(225, 229, 234, 0.75)'};
	padding: 12px 13px 12px 12px;
	display: grid;
	grid-template-columns: 112px minmax(0, 1fr) 48px;
	align-items: center;
	gap: 14px;
	cursor: pointer;
	box-shadow: none !important;
	content-visibility: auto;
	contain-intrinsic-size: 100px;
	transition:
		background-color 140ms ease,
		border-color 140ms ease,
		transform 120ms ease;

	&:not(:first-child) {
		margin-top: 12px;
	}

	&:active {
		transform: scale(0.98);
	}

	&:focus {
		outline: none;
	}

	&:focus-visible {
		outline: 2px solid rgba(155, 234, 22, 0.4);
		outline-offset: 2px;
	}

	@media (prefers-reduced-motion: reduce) {
		transition: none;

		&:active {
			transform: none;
		}
	}
`

export const ImageFrame = styled.div`
	width: 70px;
	height: 70px;
	border-radius: 16px;
	background: #f3f5f4;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
`

export const ExerciseText = styled.div`
	min-width: 0;
`

export const ExerciseTitle = styled.div`
	color: #101318;
	font-size: 16px;
	font-weight: 650;
	line-height: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`

export const PrimaryMuscle = styled.div`
	margin-top: 7px;
	color: var(--training-accent-strong, #6fbd00);
	font-size: 15px;
	font-weight: 600;
	line-height: 19px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const SecondaryMuscles = styled.div`
	margin-top: 5px;
	color: var(--training-muted, #7d8490);
	font-size: 14px;
	font-weight: 500;
	line-height: 18px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const SecondaryMuscleSeparator = styled.span`
	display: inline-block;
	margin: 0 5px;
	font-size: 42px;
	font-weight: 500;
	line-height: 0;
	vertical-align: middle;
	transform: translateY(-1px);
`

export const ActionButton = styled.button<{ $selected: boolean }>`
	width: 48px;
	height: 48px;
	border-radius: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid
		${({ $selected }) =>
			$selected ? 'rgba(220, 248, 49, 0.65)' : 'rgba(17, 24, 39, 0.035)'};
	background: ${({ $selected }) =>
		$selected ? 'var(--training-accent-soft, #f3ffe4)' : '#ffffff'};
	color: ${({ $selected }) =>
		$selected ? 'var(--training-accent-strong, #5eaa00)' : '#202631'};
	padding: 0;
	box-shadow:
		0 5px 12px rgba(17, 24, 39, 0.08),
		inset 0 1px 0 rgba(255, 255, 255, 0.72);
	transition:
		background-color 140ms ease,
		border-color 140ms ease,
		box-shadow 140ms ease,
		transform 120ms ease;

	&:active {
		transform: scale(0.96);
	}

	&:focus {
		outline: none;
	}

	&:focus-visible {
		outline: 2px solid rgba(155, 234, 22, 0.45);
		outline-offset: 2px;
	}

	svg {
		width: 22px;
		height: 22px;
		color: ${({ $selected }) =>
			$selected ? 'var(--training-accent-strong, #5eaa00)' : '#202631'};
		stroke: ${({ $selected }) =>
			$selected ? 'var(--training-accent-strong, #5eaa00)' : '#202631'};
		stroke-width: ${({ $selected }) => ($selected ? 2.8 : 2.2)};
	}

	svg * {
		color: ${({ $selected }) =>
			$selected ? 'var(--training-accent-strong, #5eaa00)' : '#202631'};
		stroke: ${({ $selected }) =>
			$selected ? 'var(--training-accent-strong, #5eaa00)' : '#202631'};
	}
`
